import { IndustryCreatePage } from "@/features/learning-content/pages/IndustryCreate";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const IndustryCreate: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <IndustryCreatePage />
      </Box>
    </Stack>
  );
};

export default IndustryCreate;
